import { useNavigate } from 'react-router-dom';
import SITE from '../data/site';
import { TestiCard } from '../components/UI';
import center from '../assets/center/clinic.jpg';
export default function About() {
  const nav = useNavigate();
  const { clinic, testimonials } = SITE;

  return (
    <div style={{ paddingTop: 72 }}>
      <div className="page-band">
        <div className="container">
          <div className="breadcrumb">
            <a onClick={() => nav('/')}>الرئيسية</a><span>/</span>من نحن
          </div>
          <h1>من نحن</h1>
        </div>
      </div>

      <section className="sec sec-warm">
        <div className="container">
          <div className="mission-grid">
            <div>
              <span className="why-eyebrow">لماذا نحن</span>
              <h2 className="why-title">لماذا تختار العراب؟</h2>
              <p className="why-desc">عيادة العراب هي واحدة من أبرز عيادات الأسنان المتخصصة في تجميل وزراعة الأسنان في مصر.</p>
              <div className="chk-list">
                {[
                  'تستمر في البحث واستقطاب أحدث التقنيات في طب الأسنان لتقديم خدمات طبية متطورة.',
                  'تقدم مستوى جديد من الخدمات الطبية المتميزة بالدقة والنجاح العالي على المستوى العالمي.',
                  'تركز على تقديم خدمات تجميل وزراعة الأسنان بأعلى معايير الجودة والكفاءة.',
                ].map((t, i) => (
                  <div className="chk-item" key={i}>
                    <div className="chk-ico">✓</div>
                    <p>{t}</p>
                  </div>
                ))}
              </div>

              <h3 style={{ fontSize: '1.15rem', fontWeight: 800, color: 'var(--dark)', margin: '22px 0 11px' }}>مهمتنا</h3>
              <p style={{ color: 'var(--textsoft)', lineHeight: 1.85, fontSize: '.94rem', marginBottom: 12 }}>
                تتمثل مهمتنا في مركز العراب في تحسين صحة وجمال الأسنان لمرضانا وتعزيز الوعي الصحي. نحن نسعى جاهدين لتوفير علاجات شاملة ومبتكرة لمشاكل الفم والأسنان، بدءًا من الوقاية وصولاً إلى العلاجات التجميلية وإعادة ترميم الأسنان المفقودة.
              </p>
              <p style={{ color: 'var(--textsoft)', lineHeight: 1.85, fontSize: '.94rem', marginBottom: 26 }}>
                نحن نعتبر كل مريض فريدًا، ونهتم بتلبية احتياجاته الفردية وتحقيق توقعاته. نلتزم بالاستمرار في تطوير مهاراتنا ومعرفتنا من خلال المشاركة في التدريب المستمر ومتابعة أحدث التقنيات والابتكارات.
              </p>
              <a className="btn btn-gold" href={clinic.whatsapp} target="_blank" rel="noreferrer">
                💬 احجز موعد استشاري
              </a>
            </div>

            <div className="mission-img">
              <div className="mission-img-ph">
               <img src={center} className="logo-img" alt={'dd'} loading='lazy' onError={e => e.target.style.display='none'} />

              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec sec-black">
        <div className="container">
          <div className="sec-head">
            <span className="sec-eyebrow">تجارب عملائنا</span>
            <h2>آراء العملاء</h2>
            <div className="gold-line" />
          </div>
          <div className="testi-grid">
            {testimonials.map((t, i) => <TestiCard key={i} {...t} />)}
          </div>
        </div>
      </section>
    </div>
  );
}
